module.exports = __webpack_public_path__ + "img/logo-red.5e4045e2.svg";